<template>
  <div class="main" id="main">
    <keep-alive>
      <router-view :key="key" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view :key="key" v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  created() {
    this.routers = this.$router.options.routes[0].children;
  },
  computed: {
    key() {
      // return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
      return this.$route.fullPath;
    },
  },
  data() {
    return {
      routers: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.main {
  flex: 1;
  font-size: 12px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>